import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { ArrowDrop } from '../../../../components/Modals/UOAModal/components/ModalArrowDrop';

const WLInitalPriceHeadings = ({
  styles,
  isMobile,
  deleteCheck,
  sethoverTabelSortLabel,
  order,
  orderBy,
  sortData,
  hoverTabelSortLabel,
  InitialPrice,
  lastPrice,
}) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          colSpan={deleteCheck ? 9 : 8}
          style={isMobile ? styles.calenderStyleMobile : styles.calenderStyle}
          align="left"
          className="fixed "
        >
          {InitialPrice}
        </TableCell>

        <TableCell
          colSpan={6}
          style={isMobile ? styles.optionStyleMobile : styles.optionStyle}
          align="left"
          className="fixed "
        >
          {lastPrice + ' ' + moment().format('DD-MMM-YYYY')}
        </TableCell>
      </TableRow>

      <TableRow style={styles.tableRow}>
        {deleteCheck && (
          <TableCell
            style={{ ...styles.TableHeaderCell }}
            className="sticky"
            align="right"
          ></TableCell>
        )}

        <TableCell
          style={{
            ...styles.TableHeaderCell,
            width: deleteCheck ? '120px' : '100px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(1);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '27px' : '',
              paddingLeft: isMobile ? '14px' : '',
            }}
            active={orderBy === 'date'}
            direction={orderBy === 'date' ? order : 'asc'}
            onClick={() => sortData('date')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'date'}
                hover={hoverTabelSortLabel}
                propertyName={1}
                direction={orderBy === 'date' ? order : 'asc'}
              />
            )}
          >
            Date
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.TableHeaderCell, padding: 0, width: '80px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(2);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '23px' : '',
            }}
            active={orderBy === 'Stock'}
            direction={orderBy === 'Stock' ? order : 'asc'}
            onClick={() => sortData('Stock')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'Stock'}
                hover={hoverTabelSortLabel}
                propertyName={2}
                direction={orderBy === 'Stock' ? order : 'asc'}
              />
            )}
          >
            Stock
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{ ...styles.TableHeaderCell, padding: 0, width: '70px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(3);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '23px' : '',
            }}
            active={orderBy === 'symbol'}
            direction={orderBy === 'symbol' ? order : 'asc'}
            onClick={() => sortData('symbol')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'symbol'}
                hover={hoverTabelSortLabel}
                propertyName={3}
                direction={orderBy === 'symbol' ? order : 'asc'}
              />
            )}
          >
            Ticker
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.TableHeaderCell,
            padding: 0,
            width: deleteCheck ? '130px' : '100px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(4);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '35px' : '',
              paddingLeft: isMobile ? '20px' : '',
            }}
            active={orderBy === 'Expiry'}
            direction={orderBy === 'Expiry' ? order : 'asc'}
            onClick={() => sortData('Expiry')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'Expiry'}
                hover={hoverTabelSortLabel}
                propertyName={4}
                direction={orderBy === 'Expiry' ? order : 'asc'}
              />
            )}
          >
            Expiry
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{ ...styles.TableHeaderCell, width: '80px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(5);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '23px' : '',
            }}
            active={orderBy === 'Strike'}
            direction={orderBy === 'Strike' ? order : 'asc'}
            onClick={() => sortData('Strike')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'Strike'}
                hover={hoverTabelSortLabel}
                propertyName={5}
                direction={orderBy === 'Strike' ? order : 'asc'}
              />
            )}
          >
            Strike
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{ ...styles.TableHeaderCell, width: '70px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(6);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={
              isMobile
                ? { color: 'white', width: '50px', paddingRight: '5px' }
                : { color: 'white', width: '50px' }
            }
            active={orderBy === 'PutCall'}
            direction={orderBy === 'PutCall' ? order : 'asc'}
            onClick={() => sortData('PutCall')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'PutCall'}
                hover={hoverTabelSortLabel}
                propertyName={6}
                direction={orderBy === 'PutCall' ? order : 'asc'}
              />
            )}
          >
            P/C
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{ ...styles.TableHeaderCell, padding: 0, width: '80px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(7);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '23px' : '',
            }}
            active={orderBy === 'Price'}
            direction={orderBy === 'Price' ? order : 'asc'}
            onClick={() => sortData('Price')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'Price'}
                hover={hoverTabelSortLabel}
                propertyName={7}
                direction={orderBy === 'Price' ? order : 'asc'}
              />
            )}
          >
            Price
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.TableHeaderCell, padding: 0, width: '80px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(8);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{
              color: 'white',
              width: '50px',
              paddingRight: isMobile ? '23px' : '',
            }}
            active={orderBy === 'RR'}
            direction={orderBy === 'RR' ? order : 'asc'}
            onClick={() => sortData('RR')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'RR'}
                hover={hoverTabelSortLabel}
                propertyName={8}
                direction={orderBy === 'RR' ? order : 'asc'}
              />
            )}
          >
            RR$
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{
            ...styles.TableHeaderCell,
            maxWidth: '60px',
            borderLeft: '1px solid',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(9);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={
              isMobile
                ? { color: 'white', width: '50px', paddingRight: '5px' }
                : { color: 'white', width: '50px' }
            }
            active={orderBy === 'secondstock'}
            direction={orderBy === 'secondstock' ? order : 'asc'}
            onClick={() => sortData('secondstock')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'secondstock'}
                hover={hoverTabelSortLabel}
                propertyName={9}
                direction={orderBy === 'secondstock' ? order : 'asc'}
              />
            )}
          >
            Stock
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.TableHeaderCell,
            padding: 0,
            paddingRight: '20px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(10);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{ color: 'white', width: '50px' }}
            active={orderBy === 'chgDollar'}
            direction={orderBy === 'chgDollar' ? order : 'asc'}
            onClick={() => sortData('chgDollar')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'chgDollar'}
                hover={hoverTabelSortLabel}
                propertyName={10}
                direction={orderBy === 'chgDollar' ? order : 'asc'}
              />
            )}
          >
            Chg$
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{
            ...styles.TableHeaderCell,
            padding: 0,
            paddingRight: '20px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(11);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={{ color: 'white', width: '50px' }}
            active={orderBy === 'chgPercent'}
            direction={orderBy === 'chgPercent' ? order : 'asc'}
            onClick={() => sortData('chgPercent')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'chgPercent'}
                hover={hoverTabelSortLabel}
                propertyName={11}
                direction={orderBy === 'chgPercent' ? order : 'asc'}
              />
            )}
          >
            Chg%
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.TableHeaderCell,
            padding: 0,
            paddingRight: '20px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(12);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={
              isMobile
                ? { color: 'white', width: '50px', paddingRight: '5px' }
                : { color: 'white', width: '50px' }
            }
            active={orderBy === 'option'}
            direction={orderBy === 'option' ? order : 'asc'}
            onClick={() => sortData('option')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'option'}
                hover={hoverTabelSortLabel}
                propertyName={12}
                direction={orderBy === 'option' ? order : 'asc'}
              />
            )}
          >
            Option
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{ ...styles.TableHeaderCell, paddingRight: '20px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(13);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={
              isMobile
                ? { color: 'white', width: '50px', paddingRight: '5px' }
                : { color: 'white', width: '50px' }
            }
            active={orderBy === 'optionchgDollar'}
            direction={orderBy === 'optionchgDollar' ? order : 'asc'}
            onClick={() => sortData('optionchgDollar')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'optionchgDollar'}
                hover={hoverTabelSortLabel}
                propertyName={13}
                direction={orderBy === 'optionchgDollar' ? order : 'asc'}
              />
            )}
          >
            Chg$
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{ ...styles.TableHeaderCell, paddingRight: '20px' }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              sethoverTabelSortLabel(14);
            }}
            onMouseOut={() => {
              sethoverTabelSortLabel('');
            }}
            style={
              isMobile
                ? { color: 'white', width: '50px', paddingRight: '5px' }
                : { color: 'white', width: '50px' }
            }
            active={orderBy === 'optionchgPercent'}
            direction={orderBy === 'optionchgPercent' ? order : 'asc'}
            onClick={() => sortData('optionchgPercent')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'optionchgPercent'}
                hover={hoverTabelSortLabel}
                propertyName={14}
                direction={orderBy === 'optionchgPercent' ? order : 'asc'}
              />
            )}
          >
            Chg%
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default WLInitalPriceHeadings;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/components/tableOneComponents/initialPrice.jsx